<script lang="ts">
  import LazyVideo from '$components/Video/LazyVideo.svelte';
  import { pageHydrated } from '$lib/stores/loadStatus';
  import { cdnAssetURL } from '$lib/utils/cdn';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  import BlockReskinLogo from './reskin_logos/BlockReskinLogo.svelte';

  export let size = 'inherit';

  let videoEl: HTMLVideoElement;
  let readyState: number;
  let videoCanPlay = false;
  let loadVideo = false;

  // If neither of our video formats is supported show video tag with poster fallback.
  // hvc1 codec is not supported on iOS 12.2 - 12.5
  const videoFormatsAreSupported = () =>
    !(
      videoEl?.canPlayType('video/quicktime; codecs="hvc1"') == '' &&
      videoEl?.canPlayType('video/webm') == ''
    );

  $: brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);

  $: {
    // 3 is a state at which there is enough data for current playback position and at least a little
    // bit of time into the future (couple frames).
    // For more details see: https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
    if (videoFormatsAreSupported() && readyState >= 3) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      videoCanPlay = true;
    }
  }

  // Defer loading of the video to after initial assets  are loaded
  $: if ($pageHydrated) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loadVideo = true;
  }
</script>

<a
  href="/"
  class={`logo size-${size}`}
  aria-label="visit home page"
  data-testid="logo"
  class:reskin={brandReskinEnabled}
>
  {#if brandReskinEnabled}
    <BlockReskinLogo />
  {:else}
    <LazyVideo
      sources={{
        webm: cdnAssetURL('/logo/webm/block_400.webm'),
        mov: cdnAssetURL('/logo/hevc/block_400.mov')
      }}
      placeholderSrc={cdnAssetURL('/logo/webp/block_400.webp')}
      alt="Block logo"
    />
  {/if}
</a>

<style lang="scss">
  .logo {
    display: block;
    width: inherit;
    height: inherit;

    &.reskin {
      color: black;
      transition: fill 0.2s ease;
      cursor: pointer;

      &:hover {
        color: #666666;
      }
    }

    &.size-20 {
      width: 20px;
      height: 20px;
    }

    &.size-32 {
      width: 32px;
      height: 32px;
    }

    &.size-40 {
      width: 40px;
      height: 40px;
    }

    &.size-80 {
      width: 80px;
      height: 80px;
    }

    &.size-200 {
      width: 200px;
      height: 200px;
    }
  }

  .logo-height {
    height: var(--logo-height);
  }

  .logo-width {
    width: var(--logo-width);
  }
</style>
